export default __webpack_public_path__ + "static/exam-room-c4aca2f2e2e549a0571d3ad5845ade70.jpg";